module.exports = {
      id: "gears-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#gears",
      toString: function () {
        return this.url;
      }
    }